import { render, staticRenderFns } from "./MailIntegrationUpdate.vue?vue&type=template&id=65c8fa2a"
import script from "./MailIntegrationUpdate.vue?vue&type=script&lang=js"
export * from "./MailIntegrationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports